import React from 'react'

interface IconProps {
  color?: string
  size?: number
  className?: string
  style?: React.CSSProperties
}

export const Plus: React.FC<IconProps> = ({
  color = '#fff',
  size = 24,
  className,
  style,
  ...rest
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.43359 7.43335V1.33335C7.43359 0.836294 7.83654 0.43335 8.33359 0.43335H9.66693C10.164 0.43335 10.5669 0.836294 10.5669 1.33335V7.43335H16.6669C17.164 7.43335 17.5669 7.83629 17.5669 8.33335V9.66668C17.5669 10.1637 17.164 10.5667 16.6669 10.5667H10.5669V16.6667C10.5669 17.1637 10.164 17.5667 9.66693 17.5667H8.33359C7.83654 17.5667 7.43359 17.1637 7.43359 16.6667V10.5667H1.33359C0.836538 10.5667 0.433594 10.1637 0.433594 9.66668V8.33335C0.433594 7.83629 0.836538 7.43335 1.33359 7.43335H7.43359Z"
      fill={color}
    />
  </svg>
)
